// material-ui
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';

// project imports
import IconButton from 'components/@extended/IconButton';
import useTour from 'hooks/useTour';

// assets
import BulbOutlined from '@ant-design/icons/BulbOutlined';

// ==============================|| HEADER CONTENT - TOUR BUTTON ||============================== //

export default function TourButton() {
  const theme = useTheme();
  const { startTour, backendTour } = useTour();

  // The tour is entirely admin-configured. Show the bulb ONLY when an enabled tour
  // is configured for this user's scope (it has steps and/or an intro page);
  // otherwise there is nothing to start, so the control is hidden rather than left
  // dead (or launching a default).
  if (!backendTour) return null;

  const handleClick = () => {
    startTour();
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 0.5 }}>
      <Tooltip title="Start Guided Tour">
        <IconButton
          color="secondary"
          variant="light"
          aria-label="start guided tour"
          onClick={handleClick}
          sx={{
            color: 'text.primary',
            '&:hover': {
              bgcolor: theme.palette.mode === 'dark' ? 'secondary.light' : 'secondary.lighter',
            },
          }}
        >
          <BulbOutlined />
        </IconButton>
      </Tooltip>
    </Box>
  );
}
